import type { QueryClient } from '@tanstack/query-core'

import { keys as admin_fund_keys } from '../fund/keystore.ts'

/**
 * Invalidates all fund-related query caches for a specific fund ID
 *
 * @param options - Configuration object
 * @param options.queryClient - The TanStack Query client instance
 * @param options.fundId - The fund ID to clear caches for
 */
export async function clear_fund_caches({
  queryClient,
  fundId,
}: {
  queryClient: QueryClient
  fundId: RubyID
}) {
  const queryKeys = [
    admin_fund_keys.admin_funds.detail(fundId).queryKey,
    admin_fund_keys.admin_funds.transactions(fundId).queryKey,
    admin_fund_keys.admin_funds.navs(fundId).queryKey,
    admin_fund_keys.admin_funds.assetNavs(fundId).queryKey,
    admin_fund_keys.admin_funds.assets(fundId).queryKey,
    admin_fund_keys.admin_funds.composition(fundId).queryKey,
    admin_fund_keys.admin_funds.all.queryKey,
  ]

  await Promise.all(
    queryKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  )
}
